<template>
  <div v-if="dialogVisible">
    <el-dialog :title="type === 'edit' ? $t('lang.Button.edit') : $t('lang.Button.Add')" :visible.sync="dialogVisible"
      width="50%" center>
      <div class="form">
        <el-form :model="connForm" :rules="rules" ref="conn" label-width="230px">
          <el-form-item :label="`${$t('lang.smartlink.enable')}：`">
            <el-checkbox v-model="connForm.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.name')}：`" prop="name">
            <el-input size="small" v-model="connForm.name" clearable class="Form-Input-Width"></el-input>
          </el-form-item>
          <!-- 修改 -->
          <el-form-item :label="`${$t('lang.smartlink.workingMode')}：`">
            <el-select size="small" v-model="connForm.mode" clearable @change="modeChange" class="Form-Input-Width">
              <el-option v-for="(value, key) of computedMode" :key="key" :label="value" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="connForm.mode == 'HTTP Client'">
            <el-form-item label="url" prop="url">
              <el-input size="mini" class="Form-Input-Width" v-model="connForm.url"></el-input>
            </el-form-item>
            <el-form-item label="请求方法" prop="method">
              <!-- <el-input size="mini" class="Form-Input-Width" v-model="connForm.url"></el-input> -->
              <el-select v-model="connForm.method">
                <el-option label="POST" value="POST"></el-option>
                <el-option label="GET" value="GET"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Http请求头" prop="header">
              <el-input size="mini" class="Form-Input-Width" v-model="connForm.header"></el-input>
            </el-form-item>
          </template>
          <!-- 自定义指令 -->
          <el-form-item :label="`自定义指令：`">
            <el-checkbox v-model="connForm.enable_daq">
            </el-checkbox>
            <p class="tips">周期发送自定义指令到终端设备</p>
          </el-form-item>
          <!-- 指令周期 -->
          <el-form-item :label="`指令周期：`" v-if="connForm.enable_daq">
            <el-input size="mini" class="Form-Input-Width" v-model="connForm.cmd_interval"></el-input>
            <p class="tips">全局指令周期，大于0时有效；等于0时，每条指令使用各种配置的周期，单位（秒）</p>
          </el-form-item>
          <!-- 指令间隔 -->
          <el-form-item :label="`指令间隔：`" v-if="connForm.enable_daq">
            <el-input size="mini" class="Form-Input-Width" v-model="connForm.cmd_period"></el-input>
            <p class="tips">同一发送周期里，相邻指令发送的时间间隔，取値：0-10000，单位（毫秒）</p>
          </el-form-item>

          <!-- 当工作模式为TCP Server或者UDP Server时显示 -->
          <el-form-item v-if="connForm.mode === 'TCP Server' || connForm.mode === 'UDP Server'"
            :label="`${$t('lang.smartlink.listenPort')}：`">
            <el-input size="small" v-model="connForm.listen_port" class="Form-Input-Width"></el-input>
          </el-form-item>
          <!-- 当工作模式为TCP Server或者UDP Client或者MQTT Client时显示 -->
          <el-form-item class="Item_content"
            v-else-if="showItem.server.includes(connForm.mode) || connForm.mode === 'S7 Client'"
            :label="`${$t('lang.smartlink.serverAddress')}：`">
            <div v-for="(item, index) in lists.server" :key="index" style="display: flex;margin-bottom: 10px">
              <div>
                <el-input size="small" class="Form-Input-Width" v-model="lists.server[index]" :class="ipColor[index]"
                  clearable></el-input>
              </div>
              <div>
                <el-button v-if="index === lists.server.length - 1" style="margin-left: 15px;" size="mini"
                  type="primary" @click="addServer">+</el-button>
                <el-button v-else style="margin-left: 15px;" size="mini" type="danger"
                  @click="deleteServer(index)">×</el-button>
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.serverTips') }}</span>
                <div v-if="ipShow" style="color: #F56C6C">{{ $t('lang.smartlink.serverError') }}</div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="Item_content" v-if="showItem.client.includes(connForm.mode)" label="本地端口">
            <el-input size="mini" class="Form-Input-Width" v-model="connForm.local_port"></el-input>
          </el-form-item>
          <!-- 当工作模式是Modbus TCP时显示和版本号是2.2时显示 -->
          <el-form-item class="Item_content" :label="`${$t('lang.smartlink.slaveAddrees')}：`"
            v-else-if="connForm.mode === 'Modbus TCP Master'">
            <div v-for="(item, index) in lists.slave_addr" :key="index" style="display: flex;margin-bottom: 10px">
              <div>
                <el-input size="small" class="Form-Input-Width" v-model="lists.slave_addr[index]"
                  :class="ipColor[index]" clearable></el-input>
              </div>
              <div>
                <el-button v-if="index === lists.slave_addr.length - 1" style="margin-left: 15px;" size="mini"
                  type="primary" @click="addSlaveAddr">+</el-button>
                <el-button v-else style="margin-left: 15px;" size="mini" type="danger"
                  @click="deleteSlaveAddr(index)">×</el-button>
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.serverTips') }}</span>
                <div v-if="ipShow" style="color: #F56C6C">{{ $t('lang.smartlink.serverError') }}</div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-else-if="connForm.mode === 'Modbus TCP Slave'" :label="`${$t('lang.smartlink.slavePort')}：`">
            <el-input size="mini" v-model="connForm.slave_port"></el-input>
          </el-form-item>
          <!-- 设备模式不同，下拉框选项不同 -->
          <el-form-item v-if="showItem.Modbus.includes(connForm.mode)" :label="`${$t('lang.smartlink.protocal')}：`">
            <el-select v-if="connForm.mode === 'Modbus TCP Master' || connForm.mode === 'Modbus TCP Slave'" size="small"
              v-model="connForm.proto_mbtcp" clearable @change="protoChange" class="Form-Input-Width">
              <el-option label="Modbus TCP" value="Modbus TCP"></el-option>
            </el-select>
            <el-select v-else-if="connForm.mode === 'Modbus RTU Master' || connForm.mode === 'Modbus RTU Slave'"
              size="small" v-model="connForm.proto_mbrtu" @change="protoChange" clearable class="Form-Input-Width">
              <el-option label="Modbus RTU" value="Modbus RTU"></el-option>
            </el-select>
            <el-select v-else-if="connForm.mode === 'Local Server'" size="small" v-model="connForm.proto"
              @change="protoChange" clearable class="Form-Input-Width">
              <el-option v-for="(value, key) of computedProtoByVender" :key="key" :label="value"
                :value="key"></el-option>
            </el-select>
            <el-select v-else-if="connForm.mode === 'Modbus ASCII Master' || connForm.mode === 'Modbus ASCII Slave'"
              size="small" v-model="connForm.proto_mbascii" @change="protoChange" clearable class="Form-Input-Width">
              <el-option label="Modbus ASCII" value="Modbus ASCII"></el-option>
            </el-select>
            <el-select v-else-if="connForm.mode === 'HTTP Client'" size="small" v-model="connForm.proto_http" clearable
              class="Form-Input-Width">
              <el-option label="HTTP" value="HTTP"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item v-else :label="`${$t('lang.smartlink.protocal')}：`">
            <el-select v-if="connForm.mode === 'S7 Client'" size="small" v-model="connForm.proto" clearable
              class="Form-Input-Width">
              <el-option label="S7" value="S7"></el-option>
            </el-select>
            <el-select v-else size="small" v-model="connForm.proto" clearable class="Form-Input-Width"
              @change="protoChange">
              <el-option v-for="(value, key) of computedProtoByVender" :key="key" :label="value"
                :value="key"></el-option>
            </el-select>
          </el-form-item>

          <!-- S7客户端协议 -->
          <el-form-item :label="`${$t('lang.smartlink.rackNumber')}：`" prop="s7_rack" v-if="connForm.proto == 'S7'">
            <el-select size="small" v-model="connForm.s7_rack" clearable class="Form-Input-Width">
              <el-option v-for="item in rackList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- S7客户端协议 -->
          <el-form-item :label="`${$t('lang.smartlink.s7_slot')}：`" prop="s7_slot" v-if="connForm.proto == 'S7'">
            <el-select size="small" v-model="connForm.s7_slot" clearable class="Form-Input-Width">
              <el-option v-for="item in slotList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- S7客户端协议 -->
          <el-form-item :label="`${$t('lang.smartlink.CollectionCycle')}：`" prop="daq_interval"
            v-if="connForm.proto == 'S7'">
            <el-input size="mini" v-model="connForm.daq_interval" class="Form-Input-Width"></el-input>
          </el-form-item>
          <!-- S7客户端协议 -->
          <el-form-item :label="`${$t('lang.smartlink.responeTimeout')}：`" prop="recv_timeout"
            v-if="connForm.proto == 'S7'">
            <el-input size="mini" v-model="connForm.recv_timeout" class="Form-Input-Width"></el-input>
          </el-form-item>

          <el-form-item :label="`${$t('lang.smartlink.serverAddress')}：`" v-if="connForm.mode === 'AIOT'">
            <el-input size="mini" v-model="connForm.aiot_server"></el-input>
          </el-form-item>
          <el-form-item label="SSL/TLS" v-if="connForm.mode === 'AIOT'">
            <el-checkbox v-model="connForm.security"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.slaveID')}：`"
            v-if="showItem.Modbus.includes(connForm.mode) && connForm.mode.indexOf('Modbus') != -1" prop="slave_id">
            <el-row>
              <el-col :span="24">
                <el-input size="mini" v-model="connForm.slave_id"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.slaveIDTips') }}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.responeTimeout')}：`"
            v-if="connForm.mode === 'Modbus TCP Master' || connForm.mode === 'Modbus ASCII Master' || connForm.mode === 'Modbus RTU Master'">
            <el-row>
              <el-col :span="24">
                <el-input size="mini" v-model="connForm.rsp_timeout"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.ms') }}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.byteInterval')}：`"
            v-if="connForm.mode === 'Modbus RTU Slave' || connForm.mode === 'Modbus ASCII Master' || connForm.mode === 'Modbus ASCII Slave' || connForm.mode === 'Modbus RTU Master'">
            <el-row>
              <el-col :span="24">
                <el-input size="mini" v-model="connForm.byte_timeout"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.ms') }}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('lang.smartlink.resendTimes') + '：'" prop="resend_times"
            v-if="connForm.mode === 'Modbus RTU Master' || connForm.mode === 'Modbus ASCII Master' || connForm.mode === 'Modbus ASCII Slave' || connForm.mode === 'Modbus RTU Slave'">
            <el-input v-model="connForm.resend_times" size="mini"></el-input>
            <p class="connTips">{{ $t('lang.smartlink.resendError') }}</p>
          </el-form-item>
          <el-form-item
            v-if="connForm.mode === 'Modbus TCP Slave' || connForm.mode === 'Modbus ASCII Slave' || connForm.mode === 'Modbus RTU Slave'"
            :label="$t('lang.smartlink.sync_local_data') + '：'" prop="sync_local_data">
            <el-checkbox v-model="connForm.sync_local_data"></el-checkbox>
            <p class="connTips">{{ $t('lang.smartlink.slaveIDTips') }}</p>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.modbusDebug')}：`"
            v-if="showItem.Modbus.includes(connForm.mode) && connForm.mode != 'Local Server' && connForm.mode != 'HTTP Client'">
            <el-checkbox v-model="connForm.modbus_debug"></el-checkbox>
          </el-form-item>
          <!-- 设备为广东质安时，协议是4G DTU显示 -->
          <div v-if="connForm.proto === '4G DTU'">
            <el-form-item :label="`${$t('lang.smartlink.platformName')}：`" prop="dtu_svr_name">
              <el-input size="small" v-model="connForm.dtu_svr_name" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.DTUNumber')}：`" prop="dtu_id">
              <el-input size="small" v-model="connForm.dtu_id" class="Form-Input-Width"></el-input>
            </el-form-item>
          </div>
          <!-- 设备为广东质安时，协议是SCTC OEM显示 -->
          <div v-if="connForm.proto === 'SCTC OEM'">
            <el-form-item :label="`${$t('lang.smartlink.corporateLogo')}：`" prop="firm_code">
              <el-input size="small" v-model="connForm.firm_code" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.deviceType')}：`" prop="dev_type">
              <el-input size="small" v-model="connForm.dev_type" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.encyptionKey')}：`" prop="dev_key">
              <el-input size="small" v-model="connForm.dev_key" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.GPSLogitude')}：`" prop="gps_lng">
              <el-input size="small" v-model="connForm.gps_lng" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.GPSLatitude')}：`" prop="gps_lat">
              <el-input size="small" v-model="connForm.gps_lat" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.keyTime')}：`" prop="key_date">
              <el-input size="small" v-model="connForm.key_date" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.deviceNumberPrefix')}：`" prop="dev_prefix">
              <el-input size="small" v-model="connForm.dev_prefix" class="Form-Input-Width"></el-input>
            </el-form-item>
          </div>
          <!-- 协议为自定义时显示 -->
          <div v-if="connForm.proto === 'Custom' || connForm.proto === 'Custom Proto'">
            <el-form-item :label="`${$t('lang.smartlink.messagePrefix')}：`" prop="msg_prefix">
              <el-row>
                <el-col :span="24">
                  <el-input v-model="connForm.msg_prefix" size="small" class="Form-Input-Width"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="connTips">{{ $t('lang.smartlink.messagePrefixTips') }}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.messageLength')}：`">
              <el-row>
                <el-col :span="24">
                  <el-select v-model="connForm.msg_len_size" size="small" class="Form-Input-Width">
                    <el-option label="0" :value="0"></el-option>
                    <el-option label="1" :value="1"></el-option>
                    <el-option label="2" :value="2"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="connTips">{{ $t('lang.smartlink.messageLengthTips') }}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.messageSequenceNumber')}：`">
              <el-row>
                <el-col :span="24">
                  <el-select v-model="connForm.msg_seq_size" size="small" class="Form-Input-Width">
                    <el-option label="0" :value="0"></el-option>
                    <el-option label="1" :value="1"></el-option>
                    <el-option label="2" :value="2"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="connTips">{{ $t('lang.smartlink.messageLengthTips') }}</span>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div v-if="connForm.proto === 'IO Control' && connForm.mode != 'Local Server'">
            <el-form-item :label="`${$t('lang.smartlink.subid')}：`">
              <el-input size="mini" v-model="connForm.did" :placeholder="deviceSn"></el-input>
            </el-form-item>
          </div>
          <!-- 协议为自定义或者Modbus JSON时显示 -->
          <el-form-item v-if="showItem.deviceId.includes(connForm.proto)" :label="`${$t('lang.smartlink.deviceID')}：`">
            <el-row v-if="showItem.didProtocol.includes(connForm.proto)">
              <el-col :span="24">
                <el-input v-model="connForm.did" :placeholder="deviceSn" size="small"
                  class="Form-Input-Width"></el-input>
              </el-col>
            </el-row>
            <el-row v-else-if="connForm.mode != 'Local Server'">
              <el-col :span="24">
                <el-input v-model="connForm.msg_dev_id" :placeholder="deviceSn" size="small"
                  class="Form-Input-Width"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.deviceIDTips') }}</span>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 协议为自定义时显示 -->
          <div v-if="connForm.proto === 'Custom' || connForm.proto === 'Custom Proto'">
            <el-form-item :label="`${$t('lang.smartlink.CRCCheck')}：`">
              <el-select size="small" v-model="connForm.msg_crc_type" class="Form-Input-Width">
                <el-option v-for="(item, index) in CRCType" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.messageSuffix')}：`" prop="msg_suffix">
              <el-row>
                <el-col :span="24">
                  <el-input v-model="connForm.msg_suffix" size="small" class="Form-Input-Width"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span class="connTips">{{ $t('lang.smartlink.messagePrefixTips') }}</span>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <!-- 工作模式是UART, RTU时显示 -->
          <el-form-item v-if="showItem.devName.includes(connForm.mode)" :label="`${$t('lang.smartlink.deviceName')}：`"
            class="Form-Input-Width">
            <el-select size="small" v-model="connForm.dev_name" class="Form-Input-Width">
              <el-option v-for="(item, index) in com" :key="index" :label="item.section"
                :value="item.section"></el-option>
            </el-select>
          </el-form-item>
          <!-- 工作模式是MQTT Client时显示 -->
          <div v-if="connForm.mode === 'MQTT Client'">
            <el-form-item :label="`${$t('lang.smartlink.username')}：`">
              <el-input v-model="connForm.username" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.password')}：`">
              <el-input v-model="connForm.password" size="small" type="password" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.subscribeTopics')}：`">
              <el-input v-model="connForm.topic_sub" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.reportingSubject')}：`">
              <el-input v-model="connForm.topic_pub" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item label="QoS：">
              <el-select v-model="connForm.mqtt_qos" class="Form-Input-Width">
                <el-option label="0" value="0"></el-option>
                <el-option label="1" value="1"></el-option>
                <el-option label="2" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.customerId')}：`">
              <el-input v-model="connForm.mqtt_cid" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.MqttSurvivalCycel')}：`">
              <el-input v-model="connForm.mqtt_alive" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
          </div>
          <div v-if="connForm.mode === 'AIOT'">
            <el-form-item label="QoS：">
              <el-select v-model="connForm.mqtt_qos" class="Form-Input-Width">
                <el-option label="0" value="0"></el-option>
                <el-option label="1" value="1"></el-option>
                <el-option label="2" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.MqttSurvivalCycel')}：`">
              <el-input v-model="connForm.mqtt_alive" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.instanceId')}：`">
              <el-input v-model="connForm.instance_id" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.productKey')}：`">
              <el-input v-model="connForm.product_key" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.deviceName')}：`">
              <el-input v-model="connForm.device_name" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.deviceSecret')}：`">
              <el-input v-model="connForm.device_secret" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.uploadInter')}：`">
              <el-input v-model="connForm.upload_inter" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="`${$t('lang.smartlink.snmpVersion')}：`">
              <el-input v-model="connForm.snmp_version" size="small" class="Form-Input-Width"></el-input>
            </el-form-item> -->
            <el-form-item :label="`${$t('lang.smartlink.snmpVersion')}：`">
              <el-select v-model="connForm.snmp_version" class="Form-Input-Width">
                <el-option label="1" value="1"></el-option>
                <el-option label="2c" value="2c"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('lang.smartlink.snmpGroupName')}：`">
              <el-input v-model="connForm.snmp_group_name" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
          </div>
          <div v-if="connForm.mode === 'UDS Server'">
            <el-form-item :label="`${$t('lang.smartlink.udsServerPath')}：`">
              <el-input disabled v-model="connForm.uds_server_path" size="small" class="Form-Input-Width"></el-input>
            </el-form-item>
          </div>
          <!-- 2.2版本及以上，自定义协议时 -->
          <el-form-item label="仅连接时上报ID："
            v-if="computedVersion >= '2.2' && connForm.proto === 'Custom' || connForm.proto === 'Custom Proto'">
            <el-checkbox v-model="connForm.msg_rep_conn"></el-checkbox>
          </el-form-item>
          <el-form-item label="仅在上报时携带ID："
            v-if="computedVersion >= '2.2' && connForm.proto === 'Custom' || connForm.proto === 'Custom Proto'">
            <el-checkbox v-model="connForm.msg_rep_conn"></el-checkbox>
          </el-form-item>
          <el-form-item
            v-if="!showItem.Modbus.includes(connForm.mode) && connForm.mode !== 'UART' && connForm.mode != 'Local Server' && !nms"
            :label="`${$t('lang.smartlink.enableHearbeat')}：`">
            <el-checkbox v-model="connForm.enable_hbt"></el-checkbox>
          </el-form-item>
          <el-form-item
            v-if="connForm.enable_hbt === true && !showItem.Modbus.includes(connForm.mode) && connForm.mode !== 'UART'"
            :label="`${$t('lang.smartlink.heartbeatInterval')}：`">
            <el-row>
              <el-col :span="24">
                <el-input size="mini" class="Form-Input-Width" v-model="connForm.hbt_interval"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.heartbeatIntervalTips') }}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            v-if="connForm.enable_hbt === true && !showItem.Modbus.includes(connForm.mode) && connForm.mode !== 'UART'"
            :label="`${$t('lang.smartlink.heartbeatContent')}：`">
            <el-row>
              <el-col :span="24">
                <el-input size="mini" class="Form-Input-Width" v-model="connForm.hbt_data"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="connTips">{{ $t('lang.smartlink.heartbeatContentTips') }}</span>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 上报周期 -->
          <el-form-item :label="`上报周期`" prop="interval"
            v-if="connForm.proto === 'Modbus JSON' || connForm.proto === 'ICP JSON'">
            <el-input v-model="connForm.interval" size="mini" class="Form-Input-Width"></el-input>
            <p class="tips">
              (秒) 当该值大于0时，表示将周期性地上报所有采集指令的结果；当该值等于0时，采集周期则以每个采集指令为准。
            </p>
          </el-form-item>
          <!-- 自动上报 -->
          <el-form-item label="自动上报" prop="auto_report" v-if="connForm.proto == 'IO Control'">
            <el-checkbox v-model="connForm.auto_report"></el-checkbox>
          </el-form-item>
          <!-- 上报触发条件 -->
          <el-form-item label="上报触发条件" prop="report_condition"
            v-if="connForm.proto == 'IO Control' && connForm.auto_report">
            <el-select size="mini" v-model="connForm.report_condition">
              <el-option label="周期上报" value="cycle"></el-option>
              <el-option label="状态变更" value="changed"></el-option>
            </el-select>
          </el-form-item>
          <!-- 上报周期 -->
          <el-form-item label="上报周期" prop="report_interval"
            v-if="connForm.proto == 'IO Control' && connForm.auto_report">
            <el-input size="mini" v-model="report_intervalf"></el-input>
            <p class="tips">秒</p>
          </el-form-item>
          <el-form-item label="断线重传" prop="offline_data" v-if="showItem.offline_data.includes(connForm.mode)">
            <el-checkbox v-model="connForm.offline_data"></el-checkbox>
          </el-form-item>
          <!-- 同步SNMP数据 -->
          <el-form-item label="同步SNMP数据" prop="sync_snmp_data" v-if="connForm.proto === 'DAQ'">
            <el-checkbox v-model="connForm.sync_snmp_data"></el-checkbox>
          </el-form-item>
          <!-- 子设备ID -->
          <el-form-item label="子设备ID" prop="sync_snmp_data"
            v-if="connForm.proto === 'IO Control' && connForm.mode == 'Local Server'">
            <!-- <el-checkbox v-model="connForm.sub_device_id"></el-checkbox> -->
            <el-input size="mini" v-model="connForm.sub_device_id"></el-input>
          </el-form-item>
          <!-- 服务器地址 -->
          <el-form-item label="服务器地址" prop="sync_snmp_data" v-if="connForm.proto === 'BlockChain'">
            <div v-for="(item, index) in lists.blockchain_ip" :key="index" style="display: flex;margin-bottom: 10px">
              <div>
                <el-input size="small" class="Form-Input-Width" v-model="lists.blockchain_ip[index]"
                  :class="ipColor[index]" clearable></el-input>
              </div>
              <div>
                <el-button v-if="index === lists.blockchain_ip.length - 1" style="margin-left: 15px;" size="mini"
                  type="primary" @click="addBlockchain_ip">+</el-button>
                <el-button v-else style="margin-left: 15px;" size="mini" type="danger"
                  @click="deleteBlockchain_ip(index)">×</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="danger" size="mini" class="Config-Buttom" @click="updateConn">{{
        $t('lang.ConfigSetting.SaveApply')
      }}</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep, isEqual } from 'lodash'
import { updateConfig } from "@/api/configurationlist"
import { workModel, CRCType, workModelOptions } from './connConfig'
import { TimeSelect } from 'element-ui'
import { setData } from './connMap'
export default {
  props: ['deviceDid', 'deviceSn', 'com', 'vendorName', 'deviceSoftwareVer', "nms"],
  data() {
    // 前后缀的正则判断
    var checkWord = (rule, value, callback) => {
      if (value) {
        var reg = /0[xX][0-9a-fA-F]+/
        if (!reg.test(value)) {
          callback(new Error(this.$t('lang.smartlink.msgError')))
        }
      }
      callback()
    }
    var checkResend = (rule, value, callback) => {
      // 只可以为0-5的数字
      if (value) {
        var reg = /^[0-5]$/
        if (!reg.test(value)) {
          callback(new Error(this.$t('lang.smartlink.resendError')))
        }
      }
      callback()
    }
    return {
      dialogVisible: false,
      type: '',
      index: 0,
      bindname: 'proto', // 协议下拉框绑定的字段名，tcp,rtu和其他工作模式情况下绑定的协议字段不一样
      // 初始化设置，防止没有字段时表单无法获取到某个字段而报错
      connForm: {
        proto: ''
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: this.$t('lang.smartlink.nameError'), trigger: 'blur' }
        ],
        msg_suffix: [
          { validator: checkWord, trigger: 'blur' }
        ],
        msg_prefix: [
          { validator: checkWord, trigger: 'blur' }
        ],
        resend_times: [
          { validator: checkResend, trigger: 'blur' }
        ],
      },
      // 地址错误提示
      ipShow: false,
      // 服务器地址数组
      lists: {
        server: [''],
        slave_addr: [''],
        blockchain_ip: ['']
      },
      ipColor: [],
      // 校验
      CRCType,
      // 工作模式
      workModel,
      // 协议
      protocal: {},
      // 原始数据，对比是否修改
      originalConn: {},
      originalLists: {},
      // 判断显示哪些表单项
      showItem: {
        server: ['TCP Client', 'UDP Client', 'MQTT Client', 'BlockChain'], // 符合显示服务器地址的表单项条件
        deviceId: ['Modbus JSON', 'Custom', 'Custom Proto', 'EHB OEM', 'ICP JSON', 'ChilinkIOT'], // 符合显示设备ID的表单项条件
        Modbus: ['Modbus TCP Master', 'Modbus TCP Slave', 'Modbus RTU Master', 'Modbus RTU Slave', 'Modbus ASCII Master', 'Modbus ASCII Slave', 'Local Server', 'HTTP Client'], //Modbus调试开关
        devName: ['Modbus RTU Master', 'Modbus RTU Slave', 'UART', 'Modbus ASCII Master', 'Modbus ASCII Slave'], //设备名称
        protocol: ['TCP Server', 'TCP Client', 'UDP Server', 'UDP Client', 'UART', 'RealCom', 'MQTT Client'],
        didProtocol: ['Modbus JSON', 'ICP JSON'],
        client: ['TCP Client', 'UDP Client',],
        offline_data: ['TCP Client', 'TCP Server', 'MQTT Client', 'HTTP Client'],
        s7: ['S7 Client']
      },
      rackList: [],
      slotList: []
    }
  },
  watch: {
    'lists.server': {
      deep: true,
      handler: function (val) {
        this.lists.server.forEach((item, index) => {
          if (item) {
            this.checkAddr(item, index)
          }
        })
      }
    },
    'lists.slave_addr': {
      deep: true,
      handler: function (val) {
        this.lists.slave_addr.forEach((item, index) => {
          if (item) {
            this.checkAddr(item, index)
          }
        })
      }
    },
  },
  computed: {
    // 计算版本
    computedVersion() {
      return this.deviceSoftwareVer.substring(1, 4)
    },
    // 计算工作模式
    computedMode() {
      let version = this.deviceSoftwareVer.substring(1, 4)
      // 2.2版本或以上
      if (version >= '2.2') {
        this.$set(this.workModel, 'Modbus TCP Master', this.$t('lang.smartlink.modbusTCPMain'))
        this.$set(this.workModel, 'Modbus TCP Slave', this.$t('lang.smartlink.modbusTCPFollow'))
        this.$set(this.workModel, 'Modbus RTU Master', this.$t('lang.smartlink.modbusRTUMain'))
        this.$set(this.workModel, 'Modbus RTU Slave', this.$t('lang.smartlink.modbusRTUFollow'))
        this.$set(this.workModel, 'HTTP Client', 'HTTP客户端')
      }
      //如果为网管服务
      if (this.nms) {
        return {
          'AIOT': this.$t('lang.smartlink.AIOT'),
          'UDS Server': this.$t('lang.smartlink.UDSServer')
        }
      }
      return this.workModel
    },
    // 根据vender计算协议,进行初始化
    computedProtoByVender() {
      let version = this.deviceSoftwareVer.substring(1, 4)
      this.protocal = {}
      switch (this.vendorName) {
        case 'OEM-CHAOYOU': // 超友科技
          this.protocal = {
            'Pass-Through': this.$t('lang.smartlink.PassThrough'),
            'CYKJ OEM': this.$t('lang.smartlink.CYKJOEM'),
          }
          break;
        case 'OEM-SHIERYE':  // 中国二十冶集团有限公司
          this.protocal = {
            'Pass-Through': this.$t('lang.smartlink.PassThrough'),
            'SHIERYE OEM': this.$t('lang.smartlink.SHIERYEOEM'),
          }
          break;
        case 'OEM-GDZADTU': // 广东质安
          this.protocal = {
            'Pass-Through': this.$t('lang.smartlink.PassThrough'),
            '4G DTU': this.$t('lang.smartlink.FourGDTU'),
            'SCTC OEM': this.$t('lang.smartlink.SCTCOEM'),
          }
          break;
        case 'OEM-EHB': // 广东E环保
          this.protocal = {
            'Pass-Through': this.$t('lang.smartlink.PassThrough'),
            'EHB OEM': this.$t('lang.smartlink.EHBOEM'),
          }
          break;
        case 'OEM-UTEPO-IOT':
          if (this.connForm.mode === "AIOT") {
            this.protocal = {
              'UTEPO': 'UTEPO'
            }
          } else {
            this.protocal = {
              'Pass-Through': this.$t('lang.smartlink.PassThrough'),
            }
          }
          break;
        default: // 默认
          if (version >= '2.2') {
            this.protocal = {
              'Pass-Through': this.$t('lang.smartlink.PassThrough'),
              'Modbus JSON': this.$t('lang.smartlink.ModbusJSON'),
              'Custom Proto': this.$t('lang.smartlink.Custom'),
            }
            if (this.showItem.protocol.includes(this.connForm.mode)) {
              this.protocal = {
                'Pass-Through': this.$t('lang.smartlink.PassThrough'),
                'Modbus JSON': this.$t('lang.smartlink.ModbusJSON'),
                'Custom Proto': this.$t('lang.smartlink.Custom'),
                'IO Control': this.$t('lang.particulars.IOControl'),
                'ICP JSON': 'ICP JSON',
                'ChilinkIOT': '智联云协议',
              }
            }
          } else {
            this.protocal = {
              'Pass-Through': this.$t('lang.smartlink.PassThrough'),
              'Modbus JSON': this.$t('lang.smartlink.ModbusJSON'),
              'Custom': this.$t('lang.smartlink.Custom'),
            }
          }
          break;
      }
      //排除网管
      if (version >= '2.3' && (!this.nms)) {
        this.$set(this.protocal, 'Modbus IOT', 'Modbus IOT')
      }
      if (this.connForm.mode == "Local Server") {
        this.protocal = {
          'DAQ': '采集数据',
          'IO Control': this.$t('lang.particulars.IOControl'),
          'BlockChain': '区块链'
        }
      }
      if (this.nms) {
        if (this.connForm.mode == "AIOT") {
          this.protocal = {
            'UTEPO': 'UTEPO'
          }
        } else {
          this.protocal = {
            'Pass-Through': this.$t('lang.smartlink.PassThrough'),
          }
        }
      }
      return this.protocal
    },
  },
  methods: {
    // 以防点击编辑后再点击添加显示的是编辑的内容
    clearData() {
      this.connForm = {}
      this.lists = {
        server: [''],
        slave_addr: [''],
        blockchain_ip: ['']
      }
    },
    protoChange(val) {
      this.$forceUpdate()
      this.connForm = setData(this.connForm, this.deviceSn, this.com)
    },
    // 工作模式发生变化
    modeChange(mode) {
      this.$forceUpdate()
      this.connForm.proto_mbtcp = ""
      this.connForm.proto_mbrtu = ""
      this.connForm.proto_mbascii = ""
      this.connForm.proto = ""
      if (this.connForm.mode === 'Modbus TCP Master' || this.connForm.mode === 'Modbus TCP Slave') {
        this.connForm.proto_mbtcp = "Modbus TCP"
      } else if (this.connForm.mode === 'Modbus RTU Master' || this.connForm.mode === 'Modbus RTU Slave') {
        this.connForm.proto_mbrtu = "Modbus RTU"
      } else if (this.connForm.mode === 'Modbus ASCII Master' || this.connForm.mode === 'Modbus ASCII Slave') {
        this.connForm.proto_mbascii = "Modbus ASCII"
      } else if (this.connForm.mode == 'Local Server') {
        this.connForm.proto = 'DAQ'
      } else if (this.connForm.mode === 'S7 Client') {
        this.connForm.proto = 'S7'
      } else {
        this.connForm.proto = Object.keys(this.computedProtoByVender)[0];
      }
      this.connForm = setData(this.connForm, this.deviceSn, this.com)
    },
    show(item, index) {
      this.clearData()
      if (item) {
        this.type = 'edit'
        this.connForm = setData(item.options, this.deviceSn, this.com)
        // 对象深拷贝，防止vue数据的双向绑定导致列表页的数据在未保存时同步更新
        this.lists = cloneDeep(item.lists)
        if (this.lists.slave_addr && this.lists.slave_addr.length <= 0) {
          this.lists.slave_addr.push('')
        }
        if (this.lists.server && this.lists.server.length <= 0) {
          this.lists.server.push('')
        }
        if (this.connForm.mode == 'Local Server') {
          this.lists.blockchain_ip = this.lists.server
        }
        for (let i = 0; i < this.lists.server.length; i++) {
          this.ipColor[i] = 'correctIP'
        }
      } else {
        this.type = 'add'
        this.connForm.mode = 'TCP Server'
        this.connForm.proto = 'Pass-Through'
        this.connForm = setData(this.connForm, this.deviceSn, this.com)
      }
      this.index = index
      this.dialogVisible = true
      this.originalLists = cloneDeep(this.lists)
      this.originalConn = cloneDeep(this.connForm)
    },
    // 验证地址
    checkAddr(item, index) {
      // 正则表达式,验证地址
      let ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/
      let domain = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
      let url = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
      let ip6 = /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/
      // 动态设置服务器地址输入框样式，输入错误则输入框为红色
      if (ip.test(item) || domain.test(item) || url.test(item) || ip6.test(item)) {
        this.ipColor[index] = 'correctIP'
      } else {
        this.ipColor[index] = 'discorrectIP'
      }
    },
    updateConn() {
      // 验证表单是否正确
      this.$refs['conn'].validate((valid) => {
        if (valid) {
          // 查找是不是有地址书写不正确
          let serverCorrect = this.ipColor.find((item) => {
            return item === 'discorrectIP'
          })
          if (!serverCorrect) {
            this.ipShow = false
            // 有内容被修改才发起修改请求
            if (!isEqual(this.originalConn, this.connForm) || !isEqual(this.originalLists, this.lists)) {
              let submitData = setData(this.connForm, this.deviceSn, this.com)
              submitData.enabled = submitData.enabled ? '1' : ''
              if (submitData.enable_hbt != undefined) {
                submitData.enable_hbt = submitData.enable_hbt ? '1' : '0'
              } else if (submitData.modbus_debug != undefined) {
                submitData.modbus_debug = submitData.modbus_debug ? '1' : '0'
              }
              if (submitData.msg_rep_conn != undefined) {
                submitData.msg_rep_conn = submitData.msg_rep_conn ? '1' : '0'
              }
              if (submitData.security != undefined) {
                submitData.security = submitData.security ? '1' : '0'
              }
              if (submitData.sync_local_data != undefined) {
                submitData.sync_local_data = submitData.sync_local_data ? '1' : '0'
              }
              if (submitData.enable_daq != undefined) {
                submitData.enable_daq = submitData.enable_daq ? '1' : '0'
              }
              if (submitData.auto_report != undefined) {
                submitData.auto_report = submitData.auto_report ? '1' : '0'
              }
              if (submitData.interval != undefined) {
                submitData.auto_report === "" ? submitData.interval = '0' : 1
              }
              if (submitData.sync_snmp_data != undefined) {
                submitData.auto_report === submitData.sync_snmp_data ? '1' : '0'
              }
              if (submitData.offline_data != undefined) {
                submitData.offline_data = submitData.offline_data ? '1' : '0'
              }
              if (submitData.custom_cmd != undefined) {
                submitData.custom_cmd = submitData.custom_cmd ? '1' : '0'
              }
              let action = 0
              action = this.type === 'edit' ? 0 : 1
              let updateObj = {
                section: "conn",
                config: this.nms ? "smartnms" : "smartlink",
                action: action,
                index: [this.index],
                server: this.nms ? "smartnms" : "smartlink",
                options: {
                  ...submitData,
                  // did:submitData.msg_dev_id,
                  // msg_dev_id:undefined
                },
              }
              // list值存在空值,增加时传到设备端会报错。编辑不会，但编辑服务器地址删除后直接传{}对象不会修改
              let myList = {}
              if (this.type === 'edit') {
                myList = this.lists
                if (submitData.mode === 'Modbus TCP Slave') {
                  myList.slave_addr = []
                } else if (submitData.mode === 'Modbus TCP Master') {
                  updateObj.options.slave_port = ''
                }
              } else {
                if (this.showItem.server.includes(submitData.mode)) { // 应该传list.server
                  if (this.connForm.mode == 'Local Server') {
                    myList = {
                      server: this.lists.blockchain_ip.filter(item => item != '')
                    }
                  } else {
                    myList = {
                      server: this.lists.server.filter(item => item != '')
                    }
                  }
                }
                if (this.showItem.Modbus.includes(submitData.mode)) { // 应该传list.slave_addr
                  if (this.lists.slave_addr.length === 1) {
                    if (this.lists.slave_addr[0]) { // 仅有一个值且不是空值
                      myList = {
                        slave_addr: this.lists.slave_addr
                      }
                    } else {
                      myList = {}
                    }
                  } else if (this.lists.slave_addr.length > 1) {
                    myList = {
                      slave_addr: this.lists.slave_addr
                    }
                  } else if (this.lists.blockchain_ip.length > 1) {
                    myList = {
                      blockchain_ip: this.lists.blockchain_ip
                    }
                  } else {
                    myList = {}
                  }
                }
              }

              if (this.showItem.server.includes(submitData.mode) || this.showItem.Modbus.includes(submitData.mode) || submitData.mode === 'S7 Client') {
                this.$set(updateObj, 'lists', myList)
              }
              // 发起请求
              updateConfig(this.deviceSn, this.deviceDid, [
                updateObj
              ]).then(res => {
                if (res.data.data.mess === 0) {
                  this.$message.success(this.$t('lang.Button.successConfiguration'))
                  this.$emit('updateData')
                  this.dialogVisible = false
                } else {
                  this.$message.error(this.$t('lang.Button.failConfiguration'))
                }
              })
            } else {
              this.dialogVisible = false
            }
          } else {
            this.ipShow = true
          }
        } else {
          return false
        }
      })
    },
    // 增加服务器地址
    addServer() {
      this.lists.server.push('')
    },
    // 增加从站
    addSlaveAddr() {
      this.lists.slave_addr.push('')
    },
    // 删除从站
    deleteSlaveAddr(index) {
      this.lists.slave_addr.splice(index, 1)
    },
    //删除服务器地址
    deleteServer(index) {
      this.lists.server.splice(index, 1)
    },
    // 删除区块链
    deleteBlockchain_ip(index) {
      this.lists.blockchain_ip.splice(index, 1)
    },
    //添加区块链
    addBlockchain_ip() {
      this.lists.blockchain_ip.push('')
    }
  },
  mounted() {
    for (let i = 0; i < 19; i++) {
      if (i < 4) {
        this.rackList.push({
          label: i.toString(),
          value: i.toString()
        })
      }
      this.slotList.push({
        label: i.toString(),
        value: i.toString()
      })
    }
  }
}
</script>
<style scoped>
.form {
  display: flex;
  justify-content: center;
}

.Form-Input-Width {
  width: 5rem;
}

.Config-Buttom {
  display: table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}

.connTips {
  color: rgb(158, 154, 154);
}

.discorrectIP>>>.el-input__inner {
  width: 5rem;
  color: red;
  border: 1px solid red;
}

.correctIP {
  width: 5rem;
}

.Item_content>>>.el-form-item__content {
  line-height: 20px !important;
}
</style>